/* Elemental Wear home + collection behaviour, 1:1 with neptun2021.de (Prestige):
   - slideshow entrance: photo fades in from 1.2x, then heading/button rise (timings measured on neptun)
   - collection: filter drawer, collapsible groups, price slider, sort pop-up, section re-render on filter/sort.
   Gate: clients/elementalwear/recon/home/gate.js */
(() => {
  if (window.__ewList) return; window.__ewList = true;
  const OUT_SINE = 'cubic-bezier(0.39, 0.575, 0.565, 1)', OUT_CUBIC = 'cubic-bezier(0.215, 0.61, 0.355, 1)';

  // ---------- slideshow entrance ----------
  const reveal = (s) => {
    if (s.dataset.revealed) return; s.dataset.revealed = '1';
    const img = [...s.querySelectorAll('.ewl-Slideshow__Image')].find(i => i.getBoundingClientRect().width > 0);
    const hdr = s.querySelector('.ewl-Slideshow__Content .ewl-SectionHeader');
    const btn = s.querySelector('.ewl-SectionHeader__ButtonWrapper');
    const go = () => {
      if (img) img.animate([{ opacity: 0, transform: 'scale(1.2)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 1310, easing: OUT_SINE, fill: 'forwards' });
      if (hdr) hdr.animate([{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 750, delay: 880, easing: OUT_CUBIC, fill: 'both' });
      if (btn) btn.animate([{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 750, delay: 880, easing: OUT_CUBIC, fill: 'both' });
    };
    if (!img || (img.complete && img.naturalWidth)) go(); else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); }
  };
  const initSlides = () => document.querySelectorAll('[data-ewl-slideshow]').forEach(reveal);

  // ---------- collection ----------
  const initCollection = (root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const drawer = root.querySelector('#ewl-filter-drawer'), pop = root.querySelector('#ewl-sort-popover'), overlay = root.querySelector('[data-ewl-overlay]');
    const form = root.querySelector('[data-ewl-filters]');
    const sortBtn = () => root.querySelector('.ewl-CollectionToolbar__Item--sort');
    const desktop = () => matchMedia('(min-width: 1008px)').matches;

    const openDrawer = () => { drawer.setAttribute('aria-hidden', 'false'); overlay.classList.add('is-visible'); document.documentElement.style.overflow = 'hidden'; };
    const closeDrawer = () => { drawer.setAttribute('aria-hidden', 'true'); overlay.classList.remove('is-visible'); document.documentElement.style.overflow = ''; };
    const placePop = () => {
      pop.classList.remove('ewl-Popover--positionTop', 'ewl-Popover--positionBottom');
      if (!desktop()) { pop.style.top = pop.style.right = ''; return; }
      const r = sortBtn().getBoundingClientRect(), h = pop.offsetHeight;
      const above = r.top - h - 20 >= 0;
      pop.classList.add(above ? 'ewl-Popover--positionTop' : 'ewl-Popover--positionBottom', 'ewl-Popover--alignRight');
      pop.style.top = (above ? r.top - h - 20 : r.bottom + 20) + 'px';
      pop.style.right = (document.documentElement.clientWidth - r.right) + 'px';
    };
    const openPop = () => { placePop(); pop.setAttribute('aria-hidden', 'false'); sortBtn().setAttribute('aria-expanded', 'true'); if (!desktop()) overlay.classList.add('is-visible'); };
    const closePop = () => { pop.setAttribute('aria-hidden', 'true'); sortBtn().setAttribute('aria-expanded', 'false'); if (drawer.getAttribute('aria-hidden') !== 'false') overlay.classList.remove('is-visible'); };

    // collapsible groups (phones; desktop shows them open)
    const toggle = (b) => {
      if (matchMedia('(min-width: 641px)').matches) return;
      const inner = b.nextElementSibling, open = b.getAttribute('aria-expanded') === 'true';
      if (open) { inner.style.height = inner.scrollHeight + 'px'; inner.offsetHeight; inner.style.height = '0px'; b.setAttribute('aria-expanded', 'false'); }
      else { form.querySelectorAll('[data-action="toggle-collapsible"][aria-expanded="true"]').forEach(o => o !== b && toggle(o)); // accordion, like neptun
        b.setAttribute('aria-expanded', 'true'); inner.style.height = inner.scrollHeight + 'px'; inner.addEventListener('transitionend', function f(e) { if (e.propertyName === 'height' && b.getAttribute('aria-expanded') === 'true') { inner.style.height = 'auto'; } inner.removeEventListener('transitionend', f); }); }
    };

    // re-render the section with the current filters + sort
    let req = 0;
    const refresh = async () => {
      const params = new URLSearchParams(new FormData(form));
      const url = location.pathname + '?' + params.toString();
      const id = ++req; const inner = root.querySelector('[data-ewl-inner]'); inner.classList.add('is-loading');
      const html = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + root.dataset.sectionId).then(r => r.text());
      if (id !== req) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nInner = doc.querySelector('[data-ewl-inner]'), nBar = doc.querySelector('[data-ewl-toolbar]');
      if (nInner) inner.replaceWith(nInner);
      if (nBar) root.querySelector('[data-ewl-toolbar]').innerHTML = nBar.innerHTML;
      // refresh counts / disabled state in the open drawer without closing it
      doc.querySelectorAll('#ewl-filter-drawer .ewl-Linklist__Checkbox').forEach(n => { const o = root.querySelector('#' + CSS.escape(n.id)); if (!o) return; o.disabled = n.disabled; const l = o.nextElementSibling, nl = n.nextElementSibling; if (l && nl) l.textContent = nl.textContent; });
      history.replaceState({}, '', url);
    };

    // price slider <-> inputs
    root.querySelectorAll('[data-ewl-price]').forEach(pr => {
      const [a, b] = pr.querySelectorAll('.range'), [fa, fb] = pr.querySelectorAll('.input-prefix__field'), g = pr.querySelector('.range-group');
      const paint = () => { const mx = +a.max || 1; g.style.setProperty('--range-min', (+a.value / mx * 100) + '%'); g.style.setProperty('--range-max', (+b.value / mx * 100) + '%'); };
      a.addEventListener('input', () => { if (+a.value > +b.value) a.value = b.value; fa.value = a.value; paint(); });
      b.addEventListener('input', () => { if (+b.value < +a.value) b.value = a.value; fb.value = b.value; paint(); });
      [a, b].forEach(r => r.addEventListener('change', refresh));
      fa.addEventListener('change', () => { a.value = fa.value || 0; paint(); });
      fb.addEventListener('change', () => { b.value = fb.value || b.max; paint(); });
    });

    form.addEventListener('change', (e) => { if (!e.target.classList.contains('range')) refresh(); });
    form.addEventListener('submit', (e) => { e.preventDefault(); refresh(); });

    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-action], .ewl-CollectionToolbar__Item--sort, [data-ewl-overlay]'); if (!t) return;
      if (t.matches('[data-ewl-overlay]')) { closeDrawer(); closePop(); return; }
      if (t.matches('.ewl-CollectionToolbar__Item--sort')) { pop.getAttribute('aria-hidden') === 'false' ? closePop() : openPop(); return; }
      const a = t.dataset.action;
      if (a === 'open-drawer') openDrawer();
      else if (a === 'close-drawer') closeDrawer();
      else if (a === 'close-popover') closePop();
      else if (a === 'toggle-collapsible') toggle(t);
      else if (a === 'select-value') {
        form.querySelector('[name="sort_by"]').value = t.dataset.value;
        pop.querySelectorAll('.ewl-Popover__Value').forEach(v => v.classList.toggle('is-selected', v === t));
        closePop(); refresh();
      }
    });
    // desktop: click outside the pop-up closes it
    document.addEventListener('click', (e) => { if (pop.getAttribute('aria-hidden') === 'false' && !pop.contains(e.target) && !e.target.closest('.ewl-CollectionToolbar__Item--sort')) closePop(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closePop(); } });
    addEventListener('resize', () => { if (pop.getAttribute('aria-hidden') === 'false') placePop(); });
    addEventListener('scroll', () => { if (pop.getAttribute('aria-hidden') === 'false' && desktop()) placePop(); }, { passive: true });
  };

  const init = () => { initSlides(); document.querySelectorAll('[data-ewl-collection]').forEach(initCollection); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
